import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 14125 16298"
    {...props}
  >
    <path
      d="M11062 64s1122-106 2002 471c318-15 575 123 742 427s471 1034 228 1475c-76 92-243-273-243-273s-121 441-348 608c30 913-334 1552-440 1765-46 122-15 228 30 350 46 122 652 2267 622 2982-31 715-394 1567-682 1856 60 594-213 1096-349 1340-137 243-440 1156-516 1581-75 427-106 883-15 1020 92 137 500 563 470 776s-470 457-682 457c-213 0-653-138-759-427s-121-791-45-1080c76-290 591-2403 288-3652-743 335-1986 320-1986 320s-213 1111-471 1749c-91 152-76 1188-76 1841 0 655 228 1674 228 1674s319 229 273 517c-45 290-410 457-728 457s-742-243-742-640c0-395 60-1292 30-1947-30-654-15-1080-122-1490-106-412-409-1491-439-2329-107 0-213-76-213-76s-500 578-849 914c45 227 167 638 167 730 0 91 91 167 242 228 152 61 622 319 607 578s-607 304-1122 76c-122-60-561-1536-622-1734-60-198-106-305-30-472 76-168 288-715 257-1035-30-319-621-821-1016-821-303 0-766 465-1106 730-409 320-879 806-1001 882s-1077 1811-1259 2313c-75 198-227 1187-1030 1157-364-31-698-426 333-1141 262-605 626-1233 648-1359 23-125 296-1689 751-3172s1126-2190 1251-2294c102-79 159-125 57-182s-1183-981-978-2944c34-228 136-171 204 354 69 524 489 1757 1422 2145 91 35 762-479 4185-731 23-604 114-1243 114-1243s-239-183-273-548c-114 183-182 229-330 206-147-23-136-730-102-1233 35-502 615-719 830-741 285-149 592-126 592-126s522-532 2001-289z"
      style={{
        fill: "#292525",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent